import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: grid;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;

export const CloseIcon = styled.div`
  color: var(--ink);
  font-size: 1.9rem;
  display: flex;
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.4rem;
  right: 1.5rem;
  background: transparent;
  border: transparent;
  cursor: pointer;
  outline: none;
`;

export const SidebarWrapper = styled.div`
  color: var(--ink);
`;

export const SidebarMenu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 72px);
  text-align: center;
  list-style: none;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(4, 64px);
  }
`;

export const SidebarLink = styled(LinkS)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 600;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  color: var(--ink);
  cursor: pointer;

  &:hover {
    color: var(--accent-strong);
  }
`;

export const SideBtnWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const SidebarRoute = styled(LinkS)`
  border-radius: var(--radius-pill);
  background: var(--ink);
  white-space: nowrap;
  padding: 14px 48px;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: var(--accent-strong);
  }
`;
